import { Link } from "react-router-dom";
import { JOYSPOT_QUIZ_URL } from "@/lib/constants";

const A = "/brand";
const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";

export function WorkWithMeCTA() {
  return (
    <section
      data-testid="work-cta-section"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "min(70vh, 600px)" }}
    >
      <img
        src={`${A}/blueprint4joy-about-swing.jpg`}
        alt="Lara on a swing in a warm, inviting moment ready to begin the journey with you."
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: "center center" }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(28,25,23,0.82) 0%, rgba(28,25,23,0.66) 34%, rgba(28,25,23,0.38) 58%, rgba(28,25,23,0.12) 80%, rgba(28,25,23,0) 100%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 md:hidden"
        style={{ background: "rgba(28,25,23,0.48)" }}
      />
      <div className="relative z-[2] max-w-7xl mx-auto pl-[8%] pr-6 md:pl-[10%] md:pr-10 pt-16 md:pt-20 pb-[43px] md:pb-[54px] min-h-[inherit] flex items-center">
        <div className="max-w-[422px] reveal text-white">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-white mb-6">
            Not Sure Where to Start?
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-white/90 max-w-lg mb-4">
            Your joy is as unique as what shapes it.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-white/90 max-w-lg mb-8">
            Take the 3-minute quiz to discover your JOYspot™ Archetype and find the path that fits.
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <a href={JOYSPOT_QUIZ_URL} data-testid="cta-joyspot" className={btnPrimary}>
              Find Your JOYspot™
            </a>
            <a
              href="mailto:lara@blueprint4joy.com"
              className="text-white text-sm font-medium hover:text-[#F6A041] underline-offset-4 hover:underline"
            >
              Or reach out directly →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
